/**
 * Claims constants + shared helpers (CC-Claims).
 *
 * The claim lifecycle FSM is salvaged data (`CLAIM_STATUS_TRANSITIONS` in
 * `src/types/api/claim.ts`) — this module only adds the presentation mappings
 * (antd Tag presets, never a purple literal) and the shared axios-error reader.
 */

import type { ClaimSide, ClaimStatus } from '@/types/api/claim';

/** antd Tag preset per lifecycle status (StatusTag precedent; no hex literals). */
export const CLAIM_STATUS_TAG_COLOR: Record<ClaimStatus, string> = {
  draft: 'default',
  submitted: 'blue',
  under_review: 'gold',
  approved: 'green',
  rejected: 'red',
  resolved: 'cyan',
};

/** antd Tag preset per side — sales vs purchasing placement. */
export const CLAIM_SIDE_TAG_COLOR: Record<ClaimSide, string> = {
  sales: 'geekblue',
  purchasing: 'purple',
};

/** Shape of the mock API error envelope (axios error response body). */
export interface ClaimApiErrorBody {
  error?: string;
  message?: string;
}

/** Read a server message out of an axios error, falling back to a localized string. */
export function extractClaimApiError(error: unknown): ClaimApiErrorBody {
  const err = error as { response?: { data?: ClaimApiErrorBody } };
  return err?.response?.data ?? {};
}
